import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { fetchMsalConfig } from "./config/authConfig";
import "./index.css"; // add any global styles here
import "./inter-font.css"; // Inter font global styles

// Initialize MSAL instance after fetching config from backend
async function initializeApp() {
  const msalConfig = await fetchMsalConfig();
  if (!msalConfig) {
    showErrorUi();
    return;
  }

  try {
    // Initialize MSAL with fetched config
    const msalInstance = new PublicClientApplication(msalConfig);

    // Render app
    ReactDOM.createRoot(document.getElementById("root")).render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </MsalProvider>
      </React.StrictMode>,
    );

    console.log("✅ React app initialized with MSAL config from backend");
  } catch (error) {
    console.error("❌ Failed to initialize app:", error);
    showErrorUi();
  }
}

/**
 * Last resort UI when unable to get login config
 */
function showErrorUi() {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        margin: 0,
        padding: 0,
      }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          backgroundColor: "#1A1A1A",
          overflow: "hidden",
        }}
      >
        <div
          style={{ textAlign: "center", maxWidth: "500px", padding: "32px" }}
        >
          <h1
            style={{
              fontWeight: 700,
              fontSize: "56px",
              lineHeight: "70px",
              color: "#DEDEDE",
              margin: "0 0 24px 0",
            }}
          >
            Could not load login
          </h1>
          <p
            style={{
              fontWeight: 400,
              fontSize: "18px",
              lineHeight: "28px",
              color: "#DEDEDE",
              margin: "0 0 47px 0",
            }}
          >
            Unable to initialize the authentication service.
          </p>
        </div>
      </div>
      <div
        style={{
          width: "50%",
          backgroundColor: "#000000",
          display: "none",
          position: "relative",
          overflow: "hidden",
          margin: 0,
          padding: 0,
        }}
      />
    </div>,
  );
}

// Start app initialization
initializeApp();
